import { Button, Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const StyledContainer = styled(Container)`
    font-family: 'Montserrat';
    color: rgba(41, 37, 97, 1);
    background: rgb(234, 222, 208, 1);
    padding: 20px 20%;
`;

const Title = styled.h1`
    font-size: 40px;
    font-weight: 700;
    padding: 40px 0px;
`;

const StyledSubmitButton = styled(Button)`
    background-color: rgba(176, 17, 22, 1);
    max-width: fit-content;
    padding: 5px 40px;
    border-radius: 25px;
    font-family: 'Montserrat';
    font-weight: 700;
    font-size: 18px;
    color: white;
    text-align: left;
`;
function NotFound() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/home');
    };

    return (
        <StyledContainer fluid>
            <Row>
                <Col>
                    <Title>404 Page Not Found!</Title>
                </Col>
            </Row>
            <Row>
                <div className="gap-2 justify-content-left">
                    <StyledSubmitButton
                        className="btn-submit me-2"
                        variant="secondary"
                        type="button"
                        onClick={(e) => {
                            handleClick(e);
                        }}
                    >
                        Go back Home
                    </StyledSubmitButton>
                </div>
            </Row>
        </StyledContainer>
    );
}

export default NotFound;
